import { useI18n } from '../i18n'
import { Chips, Sam } from '../components/bits'
import { useSession } from '../store/session'

export function CheckIn() {
  const { t } = useI18n()
  const s = useSession()

  const toggleTag = (v: string) =>
    s.set({ tags: s.tags.includes(v) ? s.tags.filter((x) => x !== v) : [...s.tags, v] })

  return (
    <section className="screen">
      <h2>{t.checkin.title}</h2>
      <Sam
        low={t.checkin.moodLow}
        name={t.checkin.moodName}
        high={t.checkin.moodHigh}
        value={s.mood}
        onPick={(v) => s.set({ mood: v })}
      />
      <Sam
        low={t.checkin.energyLow}
        name={t.checkin.energyName}
        high={t.checkin.energyHigh}
        value={s.energy}
        onPick={(v) => s.set({ energy: v })}
      />
      <p className="muted" style={{ fontSize: 13, marginTop: 6 }}>{t.checkin.tagsHint}</p>
      <Chips items={t.checkin.tags} selected={s.tags} onToggle={toggleTag} />
      <p className="muted" style={{ fontSize: 13 }}>{t.checkin.feelHint}</p>
      <textarea
        className="feel"
        placeholder={t.checkin.feelPlaceholder}
        value={s.feelText}
        onChange={(e) => s.set({ feelText: e.target.value })}
      />
      <div className="btn-row">
        <button
          className="btn btn-ink"
          disabled={s.mood == null || s.energy == null}
          onClick={() => s.go('draw')}
        >
          {t.checkin.next}
        </button>
      </div>
    </section>
  )
}
